import { CustomFieldsPage } from '@/pages/crm/settings/custom-fields/CustomFieldsPage';
import { createFileRoute } from '@tanstack/react-router';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

export const Route = createFileRoute('/_authenticated/_app/crm/settings/company-fields')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({ context, anyOf: ['crmConfig.manageFields'], redirectTo: '/dashboard' }),
	component: () => <CustomFieldsPage entityScope="Company" />,
});
